import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ReviewEntities } from 'client/data/models/dealer-reviews';
import { DEALER_PROPS, REVIEW_TITLE } from 'client/constants/dealer-reviews';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { getDealershipWriteReviewLink } from 'site-modules/shared/utils/dealership-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

function WriteAReviewLink({ params, reviewType }) {
  const { dealerState, dealerCity, logicalName } = params;
  const writeReviewLink = getDealershipWriteReviewLink({
    state: dealerState,
    city: dealerCity,
    dealership: logicalName,
    reviewType,
  });
  return (
    <div>
      <p>Be the first to write a review.</p>
      <div className="medium text-nowrap">
        <a href={writeReviewLink} className="">
          Write a {reviewType} review <span className="icon-arrow-right2 text-primary-darker xsmall" aria-hidden />
        </a>
      </div>
    </div>
  );
}

WriteAReviewLink.propTypes = {
  reviewType: PropTypes.string.isRequired,
  params: DEALER_PROPS.isRequired,
};

export function DealerReviewsOverallRating({ rating = null, reviewType, params, dealershipLink = '' }) {
  return (
    <div className="dealer-review-overall-rating">
      <div className="fw-bold">{REVIEW_TITLE[reviewType]} Rating</div>
      {rating && rating.newReviewsCount && rating.averageRating ? (
        <Fragment>
          <div className="text-primary-darker d-flex align-items-center">
            <Link to={dealershipLink} className="text-decoration-none">
              <RatingStars rating={rating.averageRating} /> ({rating.newReviewsCount})
            </Link>
            <PopoverItem
              className="text-gray-darker"
              iconClassName="size-12 px-0_25 pt-0_5 pb-0 p-md-0 position-relative align-middle"
              popoverClassName="dealer-review-overall-rating-popover"
              innerClassName="px-0_75 py-0_5 text-cool-gray-30 text-nowrap"
              placement="top"
              screenReaderTooltipLabel={`${reviewType} rating`}
              trigger="click hover focus"
            >
              Based on reviews posted in the prior 24 months.
            </PopoverItem>
          </div>
          <div className="mt-1 fw-bold">Recommend:</div>
          <div className="small text-gray-dark">
            Yes ({rating.recommended}) No ({rating.notRecommended})
          </div>
        </Fragment>
      ) : (
        <WriteAReviewLink params={params} reviewType={reviewType} />
      )}
    </div>
  );
}

DealerReviewsOverallRating.propTypes = {
  rating: ReviewEntities.OverallRatingEntity,
  reviewType: PropTypes.string.isRequired,
  params: DEALER_PROPS.isRequired,
  dealershipLink: PropTypes.string,
};
